import React, { useState } from 'react';
import { Modal, Button, Upload, Alert, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { Method_POST_CONTEXTO } from '../../../../service/api';
import { useDraggableModal } from "../Balancete/utils/modalDraggable";

const { Dragger } = Upload;

const ModalExcel = ({ show, handleClose, onUpdate, title, zIndex, onFocus }) => {
    const draggableProps = useDraggableModal(zIndex, onFocus, {
        show,
        modalKey: 'excelImport',
        initialWidth: 520,
        initialHeight: 250,
        overflow: 'visible'
    });
    const [fileList, setFileList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(null);

    // Configuração do componente de Upload do AntD
    const uploadProps = {
        onRemove: (file) => {
            setFileList([]);
        },
        beforeUpload: (file) => {
            // Permite apenas 1 arquivo e verifica extensão
            const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || file.name.endsWith('.xlsx') || file.name.endsWith('.xls');

            if (!isExcel) {
                message.error('Você só pode enviar arquivos Excel (.xlsx)!');
                return Upload.LIST_IGNORE;
            }

            setFileList([file]); // Mantém apenas o arquivo mais recente
            setErrorMsg(null);
            return false; // Retorna false para não fazer upload automático (faremos manual)
        },
        fileList,
    };

    const handleUpload = async () => {
        if (fileList.length === 0) {
            setErrorMsg('Por favor, selecione um arquivo.');
            return;
        }

        const formData = new FormData();
        formData.append('file', fileList[0]);

        setLoading(true);
        setErrorMsg(null);

        try {
            // Ajuste o endpoint conforme necessário
            const url = '/empresa/contabilidade/import/excel/lancamento';

            const response = await Method_POST_CONTEXTO(url, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            // Verifica se a API retornou erro lógico mesmo com HTTP 200 OK
            if (response && (
                response.sucesso === false || 
                response.success === false || 
                response.error || 
                response.erro || 
                response.status === 'error' ||
                (typeof response === "string" && response.toLowerCase().includes("erro"))
            )) {
                let erroMsg = 'Erro identificado na leitura da planilha.';
                
                if (response.erro && response.erro.mensagem) {
                    erroMsg = response.erro.mensagem;
                } else if (typeof response.erro === 'string') {
                    erroMsg = response.erro;
                } else if (response.mensagem) {
                    erroMsg = response.mensagem;
                } else if (response.message) {
                    erroMsg = response.message;
                } else if (typeof response.error === 'string') {
                    erroMsg = response.error;
                } else if (typeof response === 'string') {
                    erroMsg = response;
                }

                throw new Error(erroMsg);
            }

            message.success('Importação realizada com sucesso!');

            if (onUpdate) onUpdate();

            // Fecha o modal e limpa
            setFileList([]);
            handleClose();

        } catch (error) {
            console.error(error);
            let msg = 'Erro ao importar arquivo.';
            if (error.response && error.response.data && error.response.data.message) {
                msg = error.response.data.message;
            } else if (error.message) {
                msg = error.message;
            } else if (typeof error === 'string') {
                msg = error;
            }
            setErrorMsg(msg);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setFileList([]);
        setErrorMsg(null);
        handleClose();
    };

    return (
        <Modal
            title={title || "Importar Lançamentos (Excel)"}
            open={show}
            onCancel={handleCancel}
            {...draggableProps}
            styles={{ body: { overflow: 'visible' } }}
            footer={[
                <Button key="back" onClick={handleCancel} disabled={loading}>
                    Cancelar
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={loading}
                    onClick={handleUpload}
                    disabled={fileList.length === 0}
                >
                    Importar
                </Button>,
            ]}
        >
            {errorMsg && (
                <Alert
                    message="Erro"
                    description={errorMsg}
                    type="error"
                    showIcon
                    style={{ marginBottom: 16 }}
                />
            )}

            <div style={{ marginTop: 16 }}>
                <Dragger {...uploadProps} maxCount={1}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">Clique ou arraste o arquivo aqui</p>
                    <p className="ant-upload-hint">
                        Suporte apenas para arquivos .xlsx (Modelo padrão)
                    </p>
                </Dragger>
            </div>
        </Modal>
    );
};

export default ModalExcel;